module.exports = __webpack_public_path__ + "media/performance/arrow-down-94655366.svg";